import { render, staticRenderFns } from "./pbrTenderForm.vue?vue&type=template&id=77a61272&scoped=true&"
import script from "./pbrTenderForm.vue?vue&type=script&lang=js&"
export * from "./pbrTenderForm.vue?vue&type=script&lang=js&"
import style0 from "./pbrTenderForm.vue?vue&type=style&index=0&id=77a61272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a61272",
  null
  
)

export default component.exports